import { render, staticRenderFns } from "./krIndex.vue?vue&type=template&id=514b9f5d&scoped=true&"
import script from "./krIndex.vue?vue&type=script&lang=js&"
export * from "./krIndex.vue?vue&type=script&lang=js&"
import style0 from "./krIndex.vue?vue&type=style&index=0&id=514b9f5d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514b9f5d",
  null
  
)

export default component.exports